import React, { useState, useEffect, useRef } from "react";
import { BeatLoader } from "react-spinners";
import {
  getCategoryByType,
  getVirtualByCategory,
  getVirtualLab,
} from "../../api/app";
import Footer from "../../components/layout/Footer";
import { useSelector } from "react-redux";
import SEO from "../../components/layout/Seo";
import SlideShow from "../../components/layout/SlideShow";
import { Link } from "react-router-dom";
import SearchInput from "../../components/layout/SearchInput";

const Virtual = () => {
  const auth = useSelector((state) => state.auth);
  //This is for the video autoplay to work in most browsers
  const videoRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [virtual, setVirtual] = useState(null);
  const [searchVirtual, setSearchVirtual] = useState("");
  const [virtualCategories, setVirtualCategories] = useState([]);
  const [
    selectedVirtualCategoryType,
    setSelectedVirtualCategoryType,
  ] = useState(null);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  useEffect(() => {
    getVirtualLab().then((response) => {
      if (!response.error) {
        setVirtual(response.payload);
        setLoading(false);
      }
    });

    //This is for autoplay of video for most browsers with restrictions
    const attemptAutoplay = async () => {
      try {
        await videoRef.current.play();
      } catch (err) {}
    };

    if (videoRef.current) {
      attemptAutoplay();
    }
  }, []);

  useEffect(() => {
    getCategoryByType("virtual").then((response) => {
      setVirtualCategories(response.payload);
    });
  }, []);

  const filteredVirtual = virtual?.filter(
    (virtual) =>
      virtual.name.toLowerCase().includes(searchVirtual.toLowerCase()) ||
      virtual.description.toLowerCase().includes(searchVirtual.toLowerCase())
  );

  const handleSelectedVirtualCategory = (category) => {
    setSelectedCategoryId(category._id);
    setLoadingCategories(true);
    setTimeout(() => {
      getVirtualByCategory(category._id).then((response) => {
        setSelectedVirtualCategoryType(response.payload);
      });
      setLoadingCategories(false);
    }, 1000);
  };

  return (
    <div>
      <SEO title="ZStudy | Courses" description="Lists of Courses" />
      {loading ? (
        <div className="h-screen flex item-center justify-center">
          <div className="loader">
            <BeatLoader color="#003074" size={20} />
          </div>
        </div>
      ) : (
        <div className="container">
          <SearchInput
            searchQuery={searchVirtual}
            setSearchQuery={setSearchVirtual}
            placeholder="Search virtual labs by name..."
          />
          {searchVirtual?.length <= 0 && (
            <div className="overflow-hidden">
              <SlideShow type={"virtual"} />
            </div>
          )}
          <div className="md:flex justify-between items-center mb-8">
            <div>
              <div className="text-xl font-semibold">Virtual Labs</div>
              <div className="text-sm mt-2 font-medium text-gray-500 leading-6">
                {" "}
                Choose from {virtual?.length} virtual labs with new additions
                published every months
              </div>
            </div>
          </div>
          <div className="content-container grid grid-cols-1 md:grid-cols-4 gap-4">
            {/* Categories */}
            <div className="md:col-span-1 order-1 md:order-none">
              <div className="categories-container">
                <ul className="text-gray-600 mt-3">
                  {virtualCategories?.map((item) => {
                    return (
                      <li key={item._id}>
                        <div
                          className={`text-lg cursor-pointer ${
                            selectedCategoryId === item._id
                              ? "text-blue-600 font-semibold"
                              : "text-gray-600"
                          }`}
                          onClick={() => handleSelectedVirtualCategory(item)}
                        >
                          {item?.name}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            {/* Video/Content */}
            <div className="md:col-span-3 order-2 md:order-none">
              {selectedVirtualCategoryType?.length >= 1 ? (
                <>
                  {loadingCategories ? (
                    <div className="flex justify-center items-center h-40">
                      <div className="w-8 h-8 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
                    </div>
                  ) : filteredVirtual?.length === 0 ? (
                    <p className="text-center text-gray-600">
                      No virtual labs found matching your search.
                    </p>
                  ) : (
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-5">
                      {selectedVirtualCategoryType?.map((item, index) => (
                        <Link key={index} to={`/virtual-details/${item._id}`}>
                          <div className="card uk-transition-toggle">
                            <div className="card-media h-40">
                              <div className="card-media-overly"></div>
                              <img src={item.cover.uri} alt="" className="" />
                              <span className="icon-play"></span>
                            </div>
                            <div className="card-body p-4">
                              <div className="font-semibold line-clamp-2">
                                {item.name}
                              </div>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <>
                  <video
                    className="responsive-video w-full h-[30%] rounded-lg aspectRatio-16/9"
                    ref={videoRef}
                    controls
                    autoPlay
                    loop={false}
                    muted={false}
                    playsInline
                    controlsList="nodownload"
                  >
                    <source
                      src="/assets/videos/playback_video.mp4"
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                  <div>
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-5 mt-10">
                      {filteredVirtual?.map((item, index) => (
                        <Link key={index} to={`/virtual-details/${item._id}`}>
                          <div className="card uk-transition-toggle">
                            <div className="card-media h-40">
                              <div className="card-media-overly"></div>
                              <img src={item.cover.uri} alt="" className="" />
                              <span className="icon-play"></span>
                            </div>
                            <div className="card-body p-4">
                              <div className="font-semibold line-clamp-2">
                                {item.name}
                              </div>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Virtual;
